import PropTypes from "prop-types";
import { useContext, useEffect } from "react";
import { useLoaderData } from "react-router-dom";

import Colors from "../../../../../global/Colors";

import CaseSummary from "./components/sections/CaseSummary";
import ClientInfoSummary from "./components/sections/ClientInfoSummary";
import CoverageSummary from "./components/sections/CoverageSummary";
import QuickActions from "./components/sections/QuickActions";
import StatusSummary from "./components/sections/StatusSummary";
import { StatusColors } from "./components/ui/getColor";
import { StaticBarDispatchContext, StaticBarStateContext } from "./context/StaticBarContext";
import { setFieldData, setFieldMetaData } from "./state/actions";

const StaticBar = ({ docNeedsType, setUploadDocument, setViewDocuments, setOpenExpense }) => {
  const state = useContext(StaticBarStateContext);
  const dispatch = useContext(StaticBarDispatchContext);
  const { staticBarData, staticBarMetaTooltipData } = useLoaderData();

  useEffect(() => {
    setFieldData(dispatch, staticBarData);
    setFieldMetaData(dispatch, staticBarMetaTooltipData);
  }, [staticBarData, staticBarMetaTooltipData]);

  return (
    <div id="Static-Bar" data-testid="Static-Bar" className="mt-4">
      <div className="w-full">
        {state?.data && state?.ui && (
          <div
            className="border-1 flex rounded-md"
            style={{
              backgroundColor:
                state.data?.colorState?.value === StatusColors.LOST ? Colors.red[100] : Colors.white,
            }}
          >
            <div className="flex-1">
              <div className="flex">
                <ClientInfoSummary />
                <CaseSummary />
                <CoverageSummary />
                <StatusSummary />
              </div>
            </div>
            <div>
              <QuickActions
                docNeedsType={docNeedsType}
                setUploadDocument={setUploadDocument}
                setViewDocuments={setViewDocuments}
                setOpenExpense={setOpenExpense}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

StaticBar.propTypes = {
  data: PropTypes.object,
  staticBarMetaData: PropTypes.object,
  docNeedsType: PropTypes.any,
  setUploadDocument: PropTypes.func,
  setViewDocuments: PropTypes.func,
  setOpenExpense: PropTypes.func,
};

export default StaticBar;
